module.exports = __webpack_public_path__ + "img/baa1108.jpg";